import { fetchBasicOrder } from 'actions/OrderActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

/**
 * Lightweight alternative to useOrder that fetches only the basic order
 * (single /api/orders/:id call) instead of getFullOrder (8 parallel calls
 * including loyalty, payments, refunds, reservations, etc.).
 *
 * Skips the fetch entirely if order data already exists in the store
 * (e.g. from fetchOrders on the page).
 */
function useBasicOrder(orderId: string | undefined): [App.Order | undefined, boolean, any] {
  const dispatch = useAppDispatch()
  const order = useAppSelector(state => orderId ? state.orders.orders[orderId] : undefined)
  const fetching = useAppSelector(state => orderId ? !!state.orders.ordersFetching[orderId] : false)
  const error = useAppSelector(state => orderId ? state.orders.orderErrors[orderId] : undefined)

  useEffect(() => {
    if (orderId) {
      dispatch(fetchBasicOrder(orderId))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId])

  return [order, fetching, error]
}

export default useBasicOrder
